<template>
    <div>
        <slot :filterList="filterList" :categories="categories" :filteredPosts="filteredPosts"></slot>
    </div>
</template>

<script>
import { defineComponent, ref, watch } from 'vue';
import { uniq, groupBy } from 'lodash';
import { getBlogs } from '../services/inventory';

export default defineComponent({
    name: 'ProgramListing',
    props: {
        blogId: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const blog = ref(null);

        const categories = ref([]);
        const posts = props.posts.docs;
        const selectedCategory = ref('');
        const filteredPosts = ref(props.posts.docs);

        const DEFAULT = 'Select season or category';

        onMounted(async () => {
            const blogs = await getBlogs();

            blog.value = blogs.filter(blog => {
                return blog.id === props.blogId;
            })
            blog.value = blog.value[0];

            if (blog.value) {
                posts.value = blog.value.posts.docs;
                filteredPosts.value = blog.value.posts.docs;

                processCategories(posts.value);
            }
        })

        const processCategories = function(posts) {
            posts.forEach(post => {
                if (post.categories) {
                    post.categories.forEach(category => {
                        if (category.title) {
                            categories.value.push(category.title)
                        }
                    })
                }
            })

            categories.value = uniq(categories.value);
            categories.value = [DEFAULT, ...categories.value]
        }

        const filterList = function(event) {
            selectedCategory.value = event.target.value;

            filteredPosts.value = posts.filter(post => {
                if (selectedCategory.value == DEFAULT) {
                    return true;
                }

                if (post.categories) {
                    const groupedCategories = groupBy(post.categories, category => category.title);

                    return Object.keys(groupedCategories).includes(selectedCategory.value);
                } else {
                    return false;
                }
            })
        }

        return {
            filteredPosts: filteredPosts,
            filterList: filterList,
            categories: categories,
        }
    }
});

</script>


